import { render, staticRenderFns } from "./PaymentMethodsManager.vue?vue&type=template&id=bfe6311c&scoped=true&"
import script from "./PaymentMethodsManager.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodsManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe6311c",
  null
  
)

export default component.exports